export const MODAL_CONTENT = {
  received: {
    icon: require('@/assets/images/acts/recallDevice/fail-icon.png'),
    title: '领取失败',
    content: '您已经领取过啦，快去使用吧！',
    okText: '立即使用',
    popName: 'nasreceived_fail1',
  },
  nas_not_history_bind: {
    icon: require('@/assets/images/acts/recallDevice/fail-icon.png'),
    title: '领取失败',
    content: '您暂不符合老用户回归活动资格\n现在业务放量，上机纳思小星收益更可观！',
    okText: '去看看',
    cancelText: '我知道了',
    popName: 'nasreceived_fail2',
  },
  container_not_history_bind: {
    icon: require('@/assets/images/acts/recallDevice/fail-icon.png'),
    title: '领取失败',
    content: '您暂不符合老用户回归活动资格\n现在业务放量，上机容器魔方收益更可观！',
    okText: '去看看',
    cancelText: '我知道了',
    popName: 'nasreceived_fail2',
  },
  not_meet_customer: {
    icon: require('@/assets/images/acts/recallDevice/fail-icon.png'),
    title: '领取失败',
    content: '您暂不符合老用户回归活动资格\n先看看别的活动！现在晒收益享15%加成',
    okText: '去参加新活动',
    cancelText: '我知道了',
    popName: 'nasreceived_fail3',
  },
  success: {
    icon: require('@/assets/images/acts/recallDevice/success-icon.png'),
    title: '领取成功！',
    content: '15天30%加成卡\n已发放至【我的】-【权益】',
    okText: '立即使用',
    popName: 'nasreceived_successfully',
  },
};
